module.exports = __webpack_public_path__ + "img/reinigung_hausbetreuung_sicherheit.2b20c4b.svg";